export abstract class GameTabManager {
    abstract openOrFocus(gameTabName: string, oldGameTabName?: string): Promise<void>;
    abstract close(gameTabName: string): void;
}
